// extracted by mini-css-extract-plugin
export var wordContainer = "_p7-0";